import { Typography, Button } from '@material-ui/core';
import '../../styles/Globales.scss';
import '../../styles/SolicitarPortabilidad.scss';
import React, { Component } from 'react';
import TextRipleyComponent from './TextRipleyComponent';
import appStore from '../../stores/AppStore';
import AutoCompletar from './AutoCompletar';
import * as ValidationUtils from '../../utils/ValidationUtils';

const NUM_CUENTA_MAX_LENGTH = 6;

export default class DetalleCuentaBancariaComponent extends Component {
  state = {
    numeroCuenta: '',
    errortxtNumeroCuenta: '',
    errorNumeroCuenta: false,
    tipoProducto: {},
    moneda: 1,
    errorTxtMoneda: '',
    errorMoneda: false,
  };

  onChangeNumCuenta = (evt) => {
    const num = evt.target.value;
    this.setState((prevState) => {
      let numeroCuenta = prevState.numeroCuenta;
      let errorNumeroCuenta = false;
      let errortxtNumeroCuenta = '';
      if (num.length <= NUM_CUENTA_MAX_LENGTH) {
        if (ValidationUtils.isNumberOrEmpty(num)) {
          numeroCuenta = num;
        }
      }
      if (numeroCuenta.length > 0 && numeroCuenta.length < NUM_CUENTA_MAX_LENGTH) {
        errorNumeroCuenta = true;
        errortxtNumeroCuenta = 'Debes indicar los últimos ' + NUM_CUENTA_MAX_LENGTH + ' dígitos de tu número de cuenta';
      }
      return {
          numeroCuenta: numeroCuenta,
          errortxtNumeroCuenta,
          errorNumeroCuenta,
      }
    });
  };

  onAgregar = () => {
    if (this.props.onAgregar) {
      const producto = {
        codProducto: this.state.tipoProducto.codProducto,
        nombreProducto: this.state.tipoProducto.nombreProducto,
        numeroCuenta: this.state.numeroCuenta,
        moneda: this.state.moneda
      };
      this.props.onAgregar(producto);
    }
    if (this.props.onCancelar) {
      this.props.onCancelar();
    }
  };

  onCancelar = () => {
    if (this.props.onCancelar) {
      this.props.onCancelar();
    }
  };

  onChangeTipoProducto = (combo, value, label) => {
    this.setState({ tipoProducto: { codProducto: value, nombreProducto: label } });
  };

  onChangeMoneda = (combo, value) => {
    this.setState({ moneda: value });
  };

  renderDetalleProducto = (tipoProducto) => {
    let result;
    if (tipoProducto.codProducto) {
      result = (
        <div>
          <Typography className="tituloAutocompletar">Seleccione el tipo de moneda</Typography>
          <div className="autoCompletar">
            <AutoCompletar
              className="TextRipley"
              id="txtFiltroMonedas"
              fullWidth={true}
              options={appStore.monedas}
              showLabel={true}
              label="Tipo de moneda"
              placeholder="Seleccione"
              isClearable={false}
              handleChange={this.onChangeMoneda}
              valor={this.state.moneda}
              error={this.state.errorMoneda}
              errorText={this.state.errorTxtMoneda}
            ></AutoCompletar>
          </div>
          <TextRipleyComponent
            className="TextRipley"
            label="Identificación de la cuenta (Últimos 6 dígitos)"
            fullWidth={true}
            value={this.state.numeroCuenta}
            error={this.state.errorNumeroCuenta}
            errorText={this.state.errortxtNumeroCuenta}
            onChange={this.onChangeNumCuenta}
            placeholder="(opcional)"
          />
        </div>
      );
    }
    return result;
  };

  render() {
    return (
      <div>
        <Typography className="tituloStepSolicitud ">
          Elige tu <strong>cuenta bancaria</strong> e ingresa el detalle. Presiona el boton <strong>"Agregar Producto"</strong> para agregarlo a tu bolsa de portabilidad
        </Typography>
        <Typography className="tituloStepSolicitudAcordeon margin-top">Cuenta Bancaria</Typography>
        <div className="autoCompletar">
          <AutoCompletar
            options={this.props.listaTiposProductos}
            placeholder="seleccione el tipo de cuenta"
            nomCombo="cmbTiposCuentas"
            valor={this.state.tipoProducto.codProducto}
            handleChange={this.onChangeTipoProducto}
          ></AutoCompletar>
        </div>
        {this.renderDetalleProducto(this.state.tipoProducto)}
        <div className="botones">
          <Button color="primary" id="btnAgregar" className="btnRipley" fullWidth={true} onClick={this.onAgregar} disabled={!this.state.tipoProducto.codProducto}>
            Agregar Producto
          </Button>
        </div>
      </div>
    );
  }
}

DetalleCuentaBancariaComponent.defaultProps = {
  listaTiposProductos: [],
};
